import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TeamLookupResponse, TeamMemberLookupResponse, TeamLookupParams } from '../models/agent-lookup.model';

@Injectable({ providedIn: 'root' })
export class ChatTeamLookupApiService {
  private readonly base = `${environment.apiUrl}api/chat-teams`;

  constructor(private http: HttpClient) {}

  getTeams(params?: TeamLookupParams): Observable<TeamLookupResponse[]> {
    let httpParams = new HttpParams();
    if (params?.activeOnly) httpParams = httpParams.set('activeOnly', 'true');
    if (params?.includeMembers) httpParams = httpParams.set('includeMembers', 'true');
    if (params?.languageCode) httpParams = httpParams.set('languageCode', params.languageCode);
    return this.http.get<TeamLookupResponse[]>(this.base, { params: httpParams });
  }

  getTeam(id: number): Observable<TeamLookupResponse> {
    return this.http.get<TeamLookupResponse>(`${this.base}/${id}`);
  }

  getTeamMembers(teamId: number): Observable<TeamMemberLookupResponse[]> {
    return this.http.get<TeamMemberLookupResponse[]>(`${this.base}/${teamId}/members`);
  }
}
